import { IReportTamThuRequest } from "../../model/request/report/IReportTamThuRequest";
import { apiClient } from "../apiClient";
export const REPORT_TAM_THU_ENDPOINT = "report-tam-thu";

export const reportTamThuApi = {
  SelectByPaging: (request: IReportTamThuRequest) =>
    apiClient.post(`${REPORT_TAM_THU_ENDPOINT}/tong-hop`, request),
};
